import {
  Box,
  Button,
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import TableLoader from "./common/contentloader/TableLoader";
import DataGridTable from "./common/DataGridTable";

const DeployTools = () => {
  const [selectedClusters, setSelectedClusters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const clusters = [
    "eks-dev-cluster",
    "eks-prod-cluster",
    "eks-staging-cluster",
  ];

  const data = [
    {
      id: "1",
      clusterName: "eks-dev-cluster",
      awsCost: "$45.20",
      k8sCPUUsage: "230m",
      k8sMemoryUsage: "512Mi",
      k8sCostEstimate: "$12.10",
    },
    {
      id: "2",
      clusterName: "eks-prod-cluster",
      awsCost: "$180.75",
      k8sCPUUsage: "1050m",
      k8sMemoryUsage: "3.2Gi",
      k8sCostEstimate: "$75.50",
    },
    {
      id: "3",
      clusterName: "eks-staging-cluster",
      awsCost: "$78.30",
      k8sCPUUsage: "540m",
      k8sMemoryUsage: "1.5Gi",
      k8sCostEstimate: "$32.80",
    },
  ];

  const columnList = [
    {
      field: "clusterName",
      headerName: "Cluster Name",
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: "awsCost",
      headerName: "AWS Cost",
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: "k8sCPUUsage",
      headerName: "K8s CPU Usage",
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: "k8sMemoryUsage",
      headerName: "K8s Memory Usage",
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: "k8sCostEstimate",
      headerName: "K8s Cost Estimate",
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },
  ];

  const handleClusterChange = (event) => {
    setSelectedClusters(event.target.value);
  };

  const handleDeployClick = () => {
    console.log("Deploying to clusters:", selectedClusters);
  };

  return (
    <Box className="k8s-box">
      <Paper elevation={3} className="k8s-paper">
        <Grid container spacing={1} className="k8s-grid">
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Whitelist IP - CA IP, AWX IP"
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Choose the k8s cluster</InputLabel>
              <Select
                multiple
                value={selectedClusters}
                onChange={handleClusterChange}
                label="Choose the k8s cluster"
                renderValue={(selected) => selected.join(", ")}
              >
                {clusters.map((cluster) => (
                  <MenuItem key={cluster} value={cluster}>
                    <Checkbox
                      checked={selectedClusters.indexOf(cluster) > -1}
                    />
                    <ListItemText primary={cluster} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} my={2} display={'flex'} justifyContent={"center"}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleDeployClick}
            >
              Deploy
            </Button>
          </Grid>

          <Grid item xs={12}>
            {isLoading && <TableLoader />}
            {!isLoading && (
              <DataGridTable
                columns={columnList}
                rows={data}
                // showTooltip={false}
                // showPagination={true}
              />
            )}
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default DeployTools;
